import { render, staticRenderFns } from "./amortizacion-perdidas-fiscales.vue?vue&type=template&id=df9296e6&lang=html&"
import script from "./amortizacion-perdidas-fiscales.vue?vue&type=script&lang=js&"
export * from "./amortizacion-perdidas-fiscales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports